import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { customLog, stopNotificationAudio } from '../../utils/utils';

interface notificationHistory {
  id: number;
  meta: string;
  notification_details: notificationDetails;
  read: boolean;
  read_timestamp: number;
  type: string;
  user: string;
}

interface notificationDetails {
  created_timestamp: number;
  description: string;
  id : number;
  notification_type: string;
  title: string;
}

interface NotificationState {
    notificationsQueue: notificationHistory[];
    currentNotification: notificationHistory | null;

    nonCriticalNotificationQueue: notificationHistory[];
    currentNonCriticalNotification: notificationHistory | null;

    notification_id: number;
    notificationType: string;
    notificationMessage: string;
    notificationTitle: string;
    isNotificationOn: boolean;
    colorProps: {
        background: string;
        border: string;
    }
    notificationHistoryPanel: boolean;
    timestamp: number;

    isNonCriticalNotificationOn: boolean;
    activeSnackbars: notificationHistory[];

    notificationSelected: notificationHistory | null;

}

interface Notification {
  id: number;
  title: string;
  message: string;
  type: string;
  timestamp: number;
}

// interface NotificationState {
//   notificationsQueue: Notification[];
//   currentNotification: Notification | null;
//   isNotificationOn: boolean;
// }

// const initialState: NotificationState = {
//   notificationsQueue: [],
//   currentNotification: null,
//   isNotificationOn: false,
// };


const initialState: NotificationState = {
  notification_id : 0,
  notificationType: '', 
  notificationMessage: '',
  notificationTitle: '',
  isNotificationOn: false,
  colorProps: {
    background: '',
    border: ''
  },
  notificationHistoryPanel: false,
  timestamp: 0,

  notificationsQueue: [],
  currentNotification: null,

  nonCriticalNotificationQueue: [],
  currentNonCriticalNotification: null,
  activeSnackbars: [],

  isNonCriticalNotificationOn: false,
  notificationSelected: null,
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {

    // Add a notification to the queue
    // addNotification: (state, action: PayloadAction<notificationHistory>) => {
    //   // state.notificationsQueue.push(action.payload);
    //   state.notificationsQueue.unshift(action.payload);
    //   customLog("state.notificationsQueue", state.notificationsQueue);
    //   if (!state.isNotificationOn && state.notificationsQueue.length > 0) {
    //       customLog(" adding notification: display next notification");
    //       state.currentNotification = state.notificationsQueue.shift() || null;
    //       state.isNotificationOn = true;
    //       customLog("state.currentNotification", state.currentNotification, state.isNotificationOn, state.notificationsQueue);
    //   }
    // },
    addNotification: (state, action: PayloadAction<notificationHistory>) => {
      // Prevent adding duplicate notifications
      const notificationExists = state.notificationsQueue.findIndex(
        (notification) => notification.id === action.payload.id
      ) >= 0 || (state.currentNotification && state.currentNotification.id === action.payload.id);
      if (notificationExists) {
        customLog("Notification already exists, skipping add.");
        return;
      }

      let findIndexSameOrderNumber = -1
      do {
        findIndexSameOrderNumber = state.notificationsQueue.findIndex(
          (notification) => JSON.parse(notification.meta).order_number === JSON.parse(action.payload.meta).order_number
        );
  
        // If found same order_number notification  
        if (findIndexSameOrderNumber >= 0) {
          state.notificationsQueue.splice(findIndexSameOrderNumber, 1)
        }
      } while (findIndexSameOrderNumber >= 0);

      customLog("Adding notification:", action.payload);

      // If there is a current notification, push it back to the queue
      if (state.currentNotification) {
        // state.notificationsQueue.unshift(state.currentNotification);
        if (!state.notificationsQueue.find((notification) => notification.id === state.currentNotification?.id)) {
          state.notificationsQueue.push(state.currentNotification);
        }
      }
      // Set the new notification as current
      state.currentNotification = action.payload;
      state.isNotificationOn = true;
    
      customLog("Displaying the latest notification:", state.currentNotification);
      customLog("Remaining notifications in queue:", state.notificationsQueue);
    },
    
    // Display the next notification in the queue
    showNextNotification: (state) => {
      customLog("Before shifting queue 2:", state.notificationsQueue);
        state.isNotificationOn = false;
        if (state.notificationsQueue.length > 0) {
            state.notificationsQueue.shift();
            state.currentNotification = state.notificationsQueue.length > 0 ? state.notificationsQueue[0] : null;
            
            if (state.currentNotification === null) {
              state.isNotificationOn = false;
              stopNotificationAudio();
              customLog("No more notifications left, turning off 2");
              return;
            }

            if (state.currentNotification?.notification_details.notification_type === "job_notification") {
              state.notificationType = "Job Update";
            }
            else{
              state.notificationType = "Robot Update";
            }
            state.isNotificationOn = true;


        } else {
            state.currentNotification = null;
            state.isNotificationOn = false;
            stopNotificationAudio();
        }
        customLog("After shifting queue 2:", state.notificationsQueue);
        customLog("Next notification displayed 2:", state.currentNotification);
    },
      setNotificationOff2: (state) => {
        state.isNotificationOn = false;
        state.currentNotification = null;
      },

      addNonCriticalNotification: (state, action: PayloadAction<notificationHistory>) => {
        state.nonCriticalNotificationQueue.push(action.payload);
        if (!state.isNotificationOn && state.nonCriticalNotificationQueue.length > 0) {
          customLog(" adding notification: display next notification");
            state.currentNonCriticalNotification = state.nonCriticalNotificationQueue.shift() || null;
            state.isNotificationOn = true;
            customLog("state.currentNotification", state.currentNonCriticalNotification, state.isNotificationOn, state.nonCriticalNotificationQueue);
        }
      },

      setNonCriticalNotificationOn: (state) => {
        state.isNonCriticalNotificationOn = true;
      },

      showNextNonCriticalNotification: (state) => {
        customLog("Before shifting queue:", state.nonCriticalNotificationQueue);
        state.isNotificationOn = false;
        if (state.nonCriticalNotificationQueue.length > 0) {
            state.currentNonCriticalNotification = state.nonCriticalNotificationQueue.shift() || null;
            state.isNotificationOn = true;
            customLog("Shifted queue:", state.nonCriticalNotificationQueue);
            customLog("Next notification displayed:", state.currentNonCriticalNotification);
        } else {
            state.currentNonCriticalNotification = null;
            state.isNotificationOn = false;
            customLog("No more notifications left, turning off");
        }
    },
    markNotificationAsRead: (state, action: PayloadAction<{orderNo:string, notificationID:number}>) => {
      const orderNumber = action.payload.orderNo;
      const notificationID = action.payload.notificationID; 
      // remove the notification from the queue
      // state.notificationsQueue = state.notificationsQueue.filter((notification) => JSON.parse(notification.meta).order_number !== orderNumber);

      if (!state.currentNotification) {
        return
      }
      let findIndexInQueue = -1

      do{
        findIndexInQueue = state.notificationsQueue.findIndex((data) =>
          JSON.parse(data.meta).order_number === orderNumber
        )
        if (findIndexInQueue >= 0) {
          state.notificationsQueue.splice(findIndexInQueue, 1)
        }
      // loop until no more same order number in the queue
      }while (findIndexInQueue >= 0)

      if (state.currentNotification && JSON.parse(state.currentNotification.meta).order_number === orderNumber && state.currentNotification.id === notificationID) {
        if (state.notificationsQueue.length > 0) {
          state.currentNotification = state.notificationsQueue[0]
          state.isNotificationOn = true;
          return
        }
        state.currentNotification = null;
        state.isNotificationOn = false;
      }
    },

    markNotificationAsReadByID: (state, action: PayloadAction<{notificationId: number}>) => {
      const newNotifs = state.notificationsQueue.filter((item) => item.id !== action.payload.notificationId)
      state.notificationsQueue = newNotifs

      if (state.notificationsQueue.length === 0) {
        state.currentNotification = null
        state.isNotificationOn = false
      } else {
        showNextNotification()
      }
    },

    markRobotNotificationAsRead: (state, action: PayloadAction<{robot_id:string, notificationID:number}>) => {
      const robot_id = action.payload.robot_id;
      const notificationID = action.payload.notificationID;
      // state.notificationsQueue = state.notificationsQueue.filter((notification) => JSON.parse(notification.meta).robot_id !== robot_id);

      // If the current notification is the one being read, set it to null
      if (state.currentNotification && JSON.parse(state.currentNotification.meta).robot_id === robot_id && state.currentNotification.id === notificationID) {
        state.currentNotification = null;
        state.isNotificationOn = false;
      }
    },

    addNotifications: (state, action: PayloadAction<notificationHistory[]>) => {
      const uniqueNotifications = action.payload.filter(
        (notification) => !state.notificationsQueue.some((existingNotification) => existingNotification.id === notification.id)
      );
      // Add the unique notifications to the queue
      state.notificationsQueue = uniqueNotifications

      // Display the first notification if none is currently being displayed
      if (!state.isNotificationOn && uniqueNotifications.length > 0) {
        state.currentNotification = state.notificationsQueue[0]
        state.notificationsQueue.shift();

        customLog("uniqueNotifications2", state.notificationsQueue);
        if (state.currentNotification?.notification_details.notification_type === "job_notification") {
          state.notificationType = "Job Update";
        }
        else{
          state.notificationType = "Robot Update";
        }
        state.isNotificationOn = true;
      }
    },

    // addNotifications: (state, action: PayloadAction<notificationHistory[]>) => {
    //   // Filter for unique notifications not already in the queue
    //   const uniqueNotifications = action.payload.filter(
    //     (notification) => !state.notificationsQueue.some((existingNotification) => existingNotification.id === notification.id)
    //   );
      
    //   // Append unique notifications to the existing queue (instead of overwriting)
    //   state.notificationsQueue = [...state.notificationsQueue, ...uniqueNotifications];
      
    //   customLog("Unique Notifications", uniqueNotifications);
    //   customLog("Updated Notifications Queue:", state.notificationsQueue);
    
    //   // Display the first notification if none is currently being displayed
    //   if (!state.isNotificationOn && state.notificationsQueue.length > 0) {
    //     state.currentNotification = state.notificationsQueue.shift() || null;
    
    //     // Check the notification type and set it appropriately
    //     if (state.currentNotification?.notification_details.notification_type === "job_notification") {
    //       state.notificationType = "Job Update";
    //     } else {
    //       state.notificationType = "Robot Update";
    //     }
    
    //     state.isNotificationOn = true;
    
    //     customLog("Displaying the first notification:", state.currentNotification);
    //     customLog("Remaining notifications in queue:", state.notificationsQueue);
    //   }
    // },
    

    onClick : (state, action: PayloadAction<notificationHistory>) => {
      state.notificationSelected = action.payload;
    },

    resetClick : (state) => {
      state.notificationSelected = null;
    },

    toggleNotification: (state) => {
      state.isNotificationOn = !state.isNotificationOn;
    },
    setNotificationOn: (state) => {
      state.isNotificationOn = true;
    },
    setNotificationOff: (state) => {
      state.notification_id = 0;
      state.isNotificationOn = false;
      state.notificationMessage = '';
      state.notificationTitle = '';
      state.notificationType = '';
    },
    setNotificationType: (state, action: PayloadAction<string>) => {
      state.notificationType = action.payload;
    },
    setNotificationMessage: (state, action: PayloadAction<string>) => {
      state.notificationMessage = action.payload;
    },
    setNotificationTitle: (state, action: PayloadAction<string>) => {
      state.notificationTitle = action.payload;
    },
    setNotificationColorProps: (state, action: PayloadAction<{background: string, border: string}>) => {
        state.colorProps = action.payload
    },
    setNotificationHistoryPanel: (state, action: PayloadAction<boolean>) => {
        state.notificationHistoryPanel = action.payload;
    },
    setNotificationId: (state, action: PayloadAction<number>) => {
        state.notification_id = action.payload;
    },
    resetNotification: (state) => {
      state.currentNotification = null;
      state.notification_id = 0;
      state.isNotificationOn = false;
      state.notificationMessage = '';
      state.notificationTitle = '';
      state.notificationType = '';
    }
  },
});

export const {onClick, resetClick, markRobotNotificationAsRead, addNotifications, markNotificationAsRead, markNotificationAsReadByID, setNotificationOff2, showNextNotification, addNotification, setNotificationId, toggleNotification, setNotificationOn, setNotificationOff, setNotificationType, setNotificationMessage, setNotificationTitle, setNotificationColorProps, setNotificationHistoryPanel, resetNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
